export default __webpack_public_path__ + "static/media/pic13.b258f737.jpg";